import React from "react";
import MyIcon from "../MyIcon";
import AssetIcon from "../../../assets/icons/asset-01.svg2";
import MyBadge from "../MyBadge";
import { Accordion, Button } from "react-bootstrap";
import TickIcon from "../../../assets/icons/tick.svg2";

export default function AssetsFound() {
  return (
    <div className=" align-items-center rounded-3 py-4 mt-4 ps-4 pe-5 bg-purple-gradient-darker-reverse m-3 ">
      <div className="d-flex mb-3 ">
        <div>
          <MyIcon Icon={AssetIcon} width={40} className="me-2" />
        </div>
        <div>
          <div className="fw-bold">
            <MyBadge count={2} />
            <span className="fs-4 fw-bold ms-2">Assets Found</span>
          </div>
          <div className="small opacity-50 m-2">
            Lorem ipsum dolor sit amet consectetur adipisicing elit.
          </div>
        </div>
      </div>
      <div
        className="overflow-auto d-flex flex-column p-3"
        style={{
          maxHeight: 300,
          scrollbarColor:
            "var(--color-dark-purple) rgba(var(--color-blue),0.1)",
        }}
      >
        <Accordion defaultActiveKey="0" >
          <Accordion.Item eventKey="0" className="rounded-4 overflow-hidden " >
            <Accordion.Header>
              <div className="row align-items-start">
                <div className="col-2">
                  <AssetIcon width={40} className="me-2 m-2" />
                </div>

                <div className="col-10 my-2">
                  <div className="d-flex align-items-start">
                    <h5 className="fw-bold">Main Building (HQ)</h5>
                    <Button
                      type="submit"
                      size="sm"
                      className="btn btn-colored-reverse rounded-pill fw-bold ms-2 py-0"
                    >
                      4 FIELDS FOUND
                    </Button>
                  </div>
                  <h6 className="small opacity-50 ">
                    Lorem ipsum dolor sit amet consectetur...
                  </h6>
                </div>
              </div>
            </Accordion.Header>
            <Accordion.Body>
              <div className="bg-white rounded-3  row">
                <div className="col-10 offset-2">
                  <span className="d-flex align-items-center">
                    <TickIcon width={15} />
                    <h5 className=" p-1 small">geo_location</h5>
                  </span>
                  <span className="d-flex align-items-center">
                    <TickIcon width={15} />
                    <h5 className=" p-1 small">sla_guarantee</h5>
                  </span>
                  <span className="d-flex align-items-center">
                    <TickIcon width={15} />
                    <h5 className=" p-1 small">category</h5>
                  </span>
                  <span className="d-flex align-items-center">
                    <TickIcon width={15} />
                    <h5 className=" p-1 small">contacts_groups</h5>
                  </span>
                </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1" className="mt-3 rounded-4 overflow-hidden ">
            <Accordion.Header>
              <div className=" row align-items-start ">
                <div className="col-2">
                  <AssetIcon width={40} className="me-2 m-2" />
                </div>
                <div className="my-2 col-10">
                  <div className="d-flex align-items-start">
                    <h5 className="fw-bold">Server(Node 1)</h5>
                    <Button
                      type="submit"
                      size="sm"
                      className="btn btn-colored-reverse rounded-pill fw-bold py-0 ms-5"
                    >
                      8 FIELDS FOUND
                    </Button>
                  </div>
                  <h6 className="small opacity-50">
                    Lorem ipsum dolor sit amet consectet...
                  </h6>
                </div>
              </div>
            </Accordion.Header>
            <Accordion.Body>
              <div className="bg-white rounded-3 mt-3"></div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    </div>
  );
}
